import { ConnectionCheckScreen } from "@src/features/patriot-tools";

export default ConnectionCheckScreen;
